// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Styles
const Container = styled.div`
  color: ${colors.coral};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${(props) => props.margin};

  & > svg {
    height: ${(props) => props.height};
    width: ${(props) => props.width};
  }
`;

// Component
const GiftCardSvg = ({ height = '15px', margin = '0px', width = '30px' }) => (
  <Container height={height} margin={margin} width={width}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 12"
      width="33"
      role="presentation"
    >
      <g fill="#FCFBFC" fillRule="evenodd">
        <path d="M11 5c0 .55.448.998.994.998h.004c.55 0 .994-.45.994-1S12.544 4 11.994 4 11 4.448 11 5zM5.175 5.993c-.11-.314-.185-.65-.185-1C4.99 3.344 6.334 2 7.984 2c.35 0 .684.07.998.185V.4c0-.22-.176-.4-.4-.4H.998C.448 0 0 .448 0 1V5.59c0 .22.177.4.4.4h4.775zM11 2.183c.314-.11.644-.185.998-.185 1.65 0 2.994 1.345 2.994 2.996 0 .35-.07.685-.185 1h4.775c.22 0 .4-.178.4-.402V1c0-.552-.448-1-.998-1H11.4c-.22 0-.4.177-.4.4v1.783zM13.06 8l1.355 1.357c.157.157.157.41 0 .566l-.845.846c-.157.156-.41.156-.566 0L11 8.76v4.832c0 .22.177.4.4.4h7.584c.55 0 .998-.447.998-.998V8.4c0-.22-.176-.4-.4-.4H13.06zM7 5c0 .55.448.998.994.998h.004c.55 0 .994-.45.994-1S8.544 4 7.994 4 7 4.448 7 5zM8.982 9.412L7.627 10.77c-.157.156-.41.156-.566 0l-.844-.847c-.157-.157-.157-.41 0-.566L7.572 8H.402C.18 8 0 8.177 0 8.4v4.594c0 .55.448 1 .998 1h7.584c.22 0 .4-.178.4-.402v-4.18z" />
      </g>
    </svg>
  </Container>
);
GiftCardSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default GiftCardSvg;
